/**
 * PDP gallery mobile progress bar (Figma 2858-1777).
 * Aggiorna la larghezza del fill rosso in funzione dello scroll orizzontale
 * del carosello immagini (#gallery-viewer). Non tocca media-gallery.js.
 */
(function () {
  function init() {
    var viewer = document.getElementById('gallery-viewer');
    var fill = document.querySelector('.js-media-progress-fill');
    if (!viewer || !fill) return;

    var ticking = false;

    function update() {
      // Fill = immagine corrente / totale. Cosi' a scroll 0 (prima immagine)
      // mostra gia' 1/N di avanzamento rosso, rendendo chiaro che e' uno slider.
      var items = Array.prototype.filter.call(
        viewer.querySelectorAll('.media-viewer__item'),
        function (el) {
          return el.offsetWidth > 0;
        }
      );
      var total = items.length;
      if (total <= 1) {
        fill.style.width = '100%';
        ticking = false;
        return;
      }
      var itemOffset = items[1].offsetLeft - items[0].offsetLeft || 1;
      var idx = Math.round(viewer.scrollLeft / itemOffset);
      if (idx < 0) idx = 0;
      if (idx > total - 1) idx = total - 1;
      fill.style.width = ((idx + 1) / total) * 100 + '%';
      ticking = false;
    }

    viewer.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener('on:debounced-resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
